import { ModuleWithProviders, NgModule, Optional } from '@angular/core'
import { HubConfigurationService } from '@inside-hub-app/hub-configuration'
import { PpModule, PpModuleChildConfig } from '@inside-hub-app/ef-ng-pp-client'
import { NGXLogger } from 'ngx-logger'
import { TxNativeModule } from '@emilfreydigital/transifex-angular'
import { TranslateModule } from '@ngx-translate/core'
import { HubSharedTranslateModule } from './hub-shared-translate.module'

/**
 * Use this module for translation. It exports the PpModule, TranslateModule (from ngx-translate) and TxNativeModule.
 */
@NgModule({
  imports: [
    HubSharedTranslateModule
  ],
  exports: [
    TranslateModule,
    PpModule,
    TxNativeModule,
    HubSharedTranslateModule
  ]
})
export class HubChildTranslateModule {
  constructor (
    @Optional() private readonly hubConfigurationService?: HubConfigurationService,
    @Optional() private readonly logger?: NGXLogger
  ) {
    if (this.hubConfigurationService && this.logger) {
      this.hubConfigurationService.setLoggerLevel(this.logger)
    }
  }

  public static forChild (ppConfig: PpModuleChildConfig): ModuleWithProviders<HubChildTranslateModule> {
    return {
      ngModule: HubChildTranslateModule,
      providers: [
        ...PpModule.forChild(ppConfig).providers
      ]
    }
  }
}
